import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { PublicPageShell } from './components/PublicPageShell'
import { Markdown } from '@/shared/components/markdown/Markdown'
import { fetchNewsById, type NewsEntry } from '@/features/news/news'

/** Detalle público de una entrada de "Lo último" (desde la BD). */
export function NewsDetailPage() {
  const { id } = useParams<{ id: string }>()
  // undefined = cargando; null = no encontrada
  const [entry, setEntry] = useState<NewsEntry | null | undefined>(undefined)

  useEffect(() => {
    if (!id) {
      setEntry(null)
      return
    }
    let active = true
    setEntry(undefined)
    fetchNewsById(id)
      .then((d) => active && setEntry(d))
      .catch(() => active && setEntry(null))
    return () => {
      active = false
    }
  }, [id])

  if (entry === undefined) {
    return (
      <PublicPageShell backTo="/lo-ultimo" backLabel="Volver a Lo último">
        <div className="flex items-center justify-center py-20 text-muted-foreground">
          <Loader2 className="mr-2 size-5 animate-spin" /> Cargando…
        </div>
      </PublicPageShell>
    )
  }

  if (!entry) {
    return (
      <PublicPageShell backTo="/lo-ultimo" backLabel="Volver a Lo último">
        <h1 className="font-serif text-3xl">Entrada no encontrada</h1>
        <p className="mt-3 text-muted-foreground">Esta entrada no existe o no está publicada.</p>
      </PublicPageShell>
    )
  }

  return (
    <PublicPageShell backTo="/lo-ultimo" backLabel="Volver a Lo último">
      <article className="mx-auto max-w-3xl">
        <div className="mb-4 flex flex-wrap items-center gap-2">
          {entry.categories.map((c) => (
            <span key={c} className="rounded-full bg-primary/10 px-2.5 py-1 text-[11px] font-bold uppercase tracking-widest text-primary">{c}</span>
          ))}
          <span className="text-sm text-muted-foreground">{entry.date}</span>
        </div>

        <h1 className="text-3xl lg:text-4xl font-bold tracking-tight">{entry.title}</h1>

        {entry.image && (
          <img src={entry.image} alt={entry.title} className="mt-8 w-full rounded-3xl border border-black/5 object-cover" />
        )}

        <div className="mt-8">
          <Markdown>{entry.body}</Markdown>
        </div>
      </article>
    </PublicPageShell>
  )
}
